import styled from 'styled-components'  
import { AKAMAI_ENDPOINT } from 'services/api';

export const LoginSpacer = styled.div.attrs({ 
})`            
`;
 
export const CentredContent = styled.div.attrs({ 
})`  
    padding-top: 215px;
    max-width: 325px;      
    margin: 0 auto;
    ${
        props => props.big ? `
            padding-top: 310px;
        ` : ``
    }
`;

export const WhiteCard = styled.div.attrs({ 
})`           
    padding: 16px 12px 25px;
    background: var(--white-color);
    border-radius: 10px;
`;
 
export const CardTitle = styled.div.attrs({ 
})`           
    color: var(--black-color);
    font-size: 18px;
    font-weight: bold;
    margin: 0 10px;

    ${
        props => props.centred ? `
            text-align: center;
        ` : ``
    }
`;
 
export const CardText = styled.div.attrs({ 
})`           
    color: var(--black-color);
    font-size: 14px;
    text-align: center;
`;
 



export const WrapUsers = styled.div.attrs({ 
})`
    justify-content: center;   
    padding: 20px 0;
    display: flex;  
    gap: 0 25px;
`;


export const UserItem = styled.div.attrs({ 
})`       
    width: 76px;
    height: 76px;
    border-radius: 38px;
    position: relative;

    ${
        props => props.image ? `
            background: url(${ props.image }) no-repeat center center / cover;
        ` : `
            background: var(--primary-color);
            border: 5px solid var(--secondary-color);
            &:after{
                content:"+"; 
                width: 24px;
                height: 24px;
                border-radius: 12px;
                background: var(--secondary-color);
        
                display: flex;
                align-items: center;
                justify-content: center;
        
                position: absolute;
                bottom: -3px;
                right: -6px;
        
                color: var(--white-color);
                font-size: 18px;
                font-weight: bold;
            }
        `
    }

    cursor:pointer;
    &:hover{

    }
`;
  
export const UserTitle = styled.div.attrs({ 
})`           
    color: var(--primary-color);
    font-size: 30px;
    font-weight: bold; 
    text-align: center;
`; 
  
export const UserSelected = styled.div.attrs({ 
})`           
    width: 112px;
    height: 112px;
    border-radius: 56px;

    margin: 7px auto;

    background: url(${ props => props.image }) no-repeat center center / cover;
`; 

export const SelectProfileContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  text-align: center;
`;

export const SelectProfileTitle = styled.h1`
  color: white;
  font-size: 32px;
  margin-bottom: 10px;
`;

export const SelectProfileSubtitle = styled.p`
  color: #ccc;
  font-size: 18px;
  margin-bottom: 40px;
`;

export const BackToDashboardButton = styled.button`
  background: rgb(100, 100, 100);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 30px;
  
  &:hover {
    background: rgb(120, 120, 120);
  }
`;

export const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
`;

export const ProfileItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
`;

export const ProfileImage = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  border: 3px solid transparent;
  border-color: ${props => props.active ? 'rgb(247, 144, 0)' : 'rgb(252, 225, 186)'};
  transition: border-color 0.3s;
  
  &:hover {
    border-color: rgb(247, 144, 0);
  }
  
  ${props => props.active && `
    box-shadow: 0 0 20px rgba(247, 144, 0, 0.5);
  `}
`;

export const ProfileName = styled.p`
  color: ${props => props.active ? 'rgb(247, 144, 0)' : 'white'};
  font-size: 16px;
  margin: 15px 0;
  font-weight: ${props => props.active ? 'bold' : 'normal'};
`;

export const AddProfileButton = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-color: rgb(63, 63, 63);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
  
  span {
    font-size: 40px;
    color: white;
    margin-bottom: 5px;
  }
  
  p {
    color: white;
    font-size: 14px;
  }
  
  &:hover {
    background-color: rgb(247, 144, 0);
  }
`;

export const EditProfileButton = styled.button`
  background: ${props => props.delete ? 'rgb(200, 50, 50)' : 'rgb(63, 63, 63)'};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  margin-top: 5px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 14px;
  width: 100px;
  
  &:hover {
    background: ${props => props.delete ? 'rgb(240, 80, 80)' : 'rgb(80, 80, 80)'};
  }
`;

// Modal de edição de perfil
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #2a2a2a;
  border-radius: 12px;
  padding: 30px;
  width: 90%;
  max-width: 400px;
  text-align: center;
`;

export const ModalTitle = styled.h2`
  color: white;
  margin-bottom: 20px;
  font-size: 24px;
`;

export const AvatarEditContainer = styled.div`
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AvatarEditPreview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  margin-bottom: 15px;
  border: 3px solid rgb(247, 144, 0);
`;

export const ChangeImageButton = styled.button`
  background: rgb(247, 144, 0);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 20px;
  
  &:hover {
    background: rgb(220, 130, 0);
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
`;

export const ModalButton = styled.button`
  background: ${props => props.primary ? 'rgb(247, 144, 0)' : 'rgb(100, 100, 100)'};
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  min-width: 100px;
  
  &:hover {
    background: ${props => props.primary ? 'rgb(220, 130, 0)' : 'rgb(120, 120, 120)'};
  }
  
  &:disabled {
    background: rgb(60, 60, 60);
    cursor: not-allowed;
  }
`; 